import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { CellContext } from '@tanstack/react-table';

export interface LocationListAddressCellProps
  extends CellContext<GatewayLocationModel, GatewayLocationModel['address']> {}

export const LocationListAddressCell = (
  props: LocationListAddressCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
